// Return the correct price for this service for this stylist
// Used by checkout which has a different data structure to booking
export const priceForStylist = (service, stylistId, categoryServices, stylists) => {
  let newPrice = service.price;
  let originalService;
  for (let i = 0; i < categoryServices.length; i += 1) {
    for (let j = 0; j < categoryServices[i].services.length; j += 1) {
      if (categoryServices[i].services[j].id === service.id) {
        originalService = categoryServices[i].services[j];
        break;
      }
    }
    if (originalService) {
      break;
    }
  }
  if (originalService) {
    newPrice = originalService.price;
    let stylist;
    for (let i = 0; i < stylists.length; i += 1) {
      if (stylists[i].id === stylistId) {
        stylist = stylists[i];
        break;
      }
    }
    if (stylist && stylist.role && originalService.role_executions) {
      for (let i = 0; i < originalService.role_executions.length; i += 1) {
        if (originalService.role_executions[i].role_id === stylist.role.id) {
          if (originalService.role_executions[i].price || originalService.role_executions[i].price === 0) {
            newPrice = originalService.role_executions[i].price;
          }
          break;
        }
      }
    }
  }
  return newPrice;
};

// Return the correct price for this service for this stylist
export const overridesForStylist = ({ categoryServices, service, stylistId, stylists }) => {
  const { price: oldPrice, duration: oldDuration, processing: oldProcessing, is_custom_price: isCustomPrice, is_custom_processing: isCustomProcessing, is_custom_duration: isCustomDuration } = service;

  let originalService;
  for (let i = 0; i < categoryServices.length; i += 1) {
    for (let j = 0; j < categoryServices[i].services.length; j += 1) {
      if (categoryServices[i].services[j].id === service.service_id) {
        originalService = categoryServices[i].services[j];
        break;
      }
    }
    if (originalService) {
      break;
    }
  }

  if (!originalService) {
    return {
      price: oldPrice,
      duration: oldDuration,
      processing: oldProcessing,
    };
  }

  let { price: newPrice, duration: newDuration, processing: newProcessing } = originalService;

  let stylist;
  for (let i = 0; i < stylists.length; i += 1) {
    if (stylists[i].id === stylistId) {
      stylist = stylists[i];
      break;
    }
  }

  const { role_executions: executions } = originalService;
  if (stylist && stylist.role && executions) {
    for (let i = 0; i < executions.length; i += 1) {
      if (executions[i].role_id === stylist.role.id) {
        if (executions[i].price || executions[i].price === 0) {
          newPrice = executions[i].price;
        }
        if (executions[i].duration) {
          newDuration = executions[i].duration;
        }
        if (executions[i].processing) {
          newProcessing = executions[i].processing;
        }
        break;
      }
    }
  }

  // do not override custom price and times, keep them as they are
  return {
    price: isCustomPrice ? oldPrice : newPrice,
    duration: isCustomDuration ? oldDuration : newDuration,
    processing: isCustomProcessing ? oldProcessing : newProcessing,
  };
};
